import { render, staticRenderFns } from "./template.vue?vue&type=template&id=73bc76b6&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=73bc76b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bc76b6",
  null
  
)

export default component.exports